import React from 'react';
import { Dropdown, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ModalStackPropsBase } from './ModalStackProvider';
import { Language } from '../../utils/constants/CommonConstants';

interface TermModalProps extends ModalStackPropsBase<unknown, unknown> {
  onSubmit: () => void;
  onClose: () => void;
  show?: boolean;
}
const TermModal: React.FC<TermModalProps> = ({ onSubmit, onClose, show }) => {
  const { i18n, t } = useTranslation();
  const currentLangItem = Language.getLangByKey(i18n.language.substring(0, 2));
  const languages = [Language.en, Language.th];

  const handleSubmit = () => {
    onSubmit();
  };

  return (
    <Modal show={show} dialogClassName="modal-xxl" onHide={onClose} backdrop="static">
      <Modal.Body className="modal-condition-height">
        <div className="modal-body-left-bg top-0">
          <div className="nav nav-tab">
            <a className="nav-item active">{t('Common.Consent.TermsOfService')}</a>
          </div>
          <div className="language">
            <Dropdown bsPrefix=" " className="dropdown-inline dropdown-sm">
              <Dropdown.Toggle as="button" bsPrefix="dropdown-toggle" variant="">
                <i className="icon-language mr-4px"></i>
                <span>{currentLangItem?.title}</span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu-right">
                {languages.map((lang) => {
                  return (
                    <Dropdown.Item
                      onSelect={() => i18n.changeLanguage(lang.key)}
                      key={'switch-lang-' + lang.key}
                    >
                      {lang.title}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <div className="modal-body-right">
          <div className="tab-content">
            <div id="tab-1" className="tab-pane active"></div>
            <div className="modal-title mb-8">
              ข้อกำหนดและเงื่อนไขการใช้งานระบบ Pantavanij Intelligence
            </div>
            <p className="color-sub">อัปเดทเมื่อ 31 มีนาคม พ.ศ. 2566</p>
            <div className="title">
              <div className="mb-3">
                <p>
                  ข้อกำหนดและเงื่อนไขการใช้งานระบบ Pantavanij Intelligence (“ระบบ PI”) นี้
                  ("ข้อกำหนดและเงื่อนไข") มีผลใช้บังคับกับผู้ใช้งานระบบ PI ("ผู้ใช้งาน")
                  ในทันทีที่ผู้ใช้งานกดยอมรับ (Accept)
                  และยืนยันตัวตนผ่านทางจดหมายอิเล็กทรอนิกส์ที่ลงทะเบียนไว้ ("วันที่มีผลใช้บังคับ")
                  โดยพันธวณิชอาจแก้ไขเพิ่มเติมข้อกำหนดและเงื่อนไขโดยไม่แจ้งล่วงหน้า
                  พันธวณิชแนะนำให้ท่านตรวจสอบข้อกำหนดและเงื่อนไขนี้เป็นประจำ การที่ท่านใช้งานระบบ PI
                  ต่อไป หลังจากที่มีการเปลี่ยนแปลงข้อกำหนดและเงื่อนไข
                  ถือว่าท่านยอมรับการเปลี่ยนแปลงนั้นแล้ว
                </p>
              </div>
              <div className="mb-3">
                <ul>
                  <li>
                    <b>1. คำนิยาม</b>
                    <br />
                    <ol>
                      <br />
                      <li>
                        "ระบบ <b>Pantavanij Intelligence</b> (“ระบบ PI”) "
                        ระบบศูนย์กลางที่รวมข้อมูลการจัดซื้อสินค้าและ/หรือบริการของผู้ซื้อรวมถึงข้อมูลสินค้าและ/หรือบริการของผู้ขาย
                        ที่ให้บริการโดย บริษัท พันธวณิช จำกัด
                        พร้อมทั้งมีระบบการวิเคราะห์ข้อมูลการจัดซื้อ
                        เพื่อให้ผู้ซื้อได้ซื้อสินค้าและ/หรือบริการตรงตามเป้าหมาย
                        และเพิ่มโอกาสการลดต้นทุน
                        และผู้ขายสามารถพบลูกค้าที่ตรงตามกลุ่มเป้าหมายได้เร็วขึ้น
                        ซึ่งจะเพิ่มโอกาสในการขายสินค้า และ/หรือบริการได้มากขึ้น
                      </li>
                      <br />
                      <li>
                        "<b>บอร์ดประกาศจัดซื้อ (Procurement Board)</b>" หมายถึง
                        รายการประกาศความต้องการสรรหาสินค้า และ/หรือบริการของผู้ซื้อ
                        โดยมีระยะมีเวลาเริ่มต้นและสิ้นสุดของรายการประกาศ
                      </li>
                      <br />
                      <li>
                        "<b>แพ็คเกจ</b>" หมายถึง สิทธิประโยชน์ต่าง ๆ
                        ที่ผู้ขายจะได้รับหลังจากทำการสมัครและชำระค่าบริการเรียบร้อยแล้ว
                      </li>
                      <br />
                      <li>
                        "<b>พันธวณิช</b>" หมายถึง บริษัท พันธวณิช จำกัด ในฐานะผู้ให้บริการระบบ PI
                      </li>
                      <br />
                      <li>
                        ผู้ใช้งานระบบ PI ("<b>ผู้ใช้งาน</b>") หมายถึง ผู้ซื้อ
                        หรือผู้ขายที่ใช้งานระบบ PI
                      </li>
                      <br />
                      <li>
                        "<b>ข้อมูลแสดงตัวผู้ใช้งาน</b>" หมายถึง ชื่อผู้ใช้ (USERNAME) และรหัสผ่าน
                        (PASSWORD) ซึ่งใช้ในการเข้าใช้งานระบบ PI
                      </li>
                      <br />
                      <li>
                        "<b>บัญชีผู้ใช้งาน</b>" หมายถึง
                        บัญชีผู้ใช้งานทั้งหมดที่ผู้ใช้งานมอบหมายให้บุคคลใดบุคคลหนึ่งหรือหลายบุคคลใช้งานภายในระบบ
                        PI โดยให้ถือว่าการกระทำใด ๆ
                        ที่เกิดขึ้นจากบัญชีผู้ใช้งานทั้งหมดดังกล่าวเป็นการกระทำของผู้ใช้งานเองโดยปราศจากข้อโต้แย้ง
                      </li>
                      <br />
                      <li>
                        "<b>การใช้งาน</b>" หมายถึง คำสั่ง การเข้าถึงข้อมูล การจัดเก็บข้อมูล
                        และการเรียกดูข้อมูลผ่านโปรแกรมคอมพิวเตอร์
                      </li>
                      <br />
                      <li>
                        "<b>ข้อมูล</b>" หมายถึง ตัวอักษร ข้อความ เครื่องหมาย รูปภาพ เสียง วัตถุ
                        หรือสื่ออื่นใดที่ถูกใช้เพื่อวัตถุประสงค์ในทางเดียวกัน
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <b>2. สิทธิในการใช้งานระบบ PI</b>
                    <br />
                    <br />
                    <ol>
                      <br />
                      ผู้ใช้งานตกลงและรับทราบอย่างชัดเจน ตามรายละเอียดต่อไปนี้
                      <br />
                      <br />
                      <li>
                        2.1 ผู้ใช้งานตกลงใช้บริการระบบ PI และพันธวณิชตกลงให้บริการระบบ PI
                        แก่ผู้ใช้งาน โดยผู้ใช้งานซึ่งเป็นผู้ซื้อสามารถใช้บริการได้โดยไม่มีค่าบริการ
                        แต่ในกรณีที่ผู้ใช้งานเป็นผู้ขายจะสามารถใช้งานระบบ PI ได้ภายใต้ระยะเวลา
                        และเงื่อนไขของแพ็คเกจที่ผู้ขายเลือกซื้อเท่านั้น (สำหรับช่วงทดลองใช้งานระบบ
                        PI พันธวณิชให้สิทธิผู้ขายใช้งานโดยไม่มีค่าบริการภายใต้ระยะเวลาที่กำหนด)
                      </li>
                      <br />
                      <li>
                        2.2 แพ็คเกจการใช้งานจะไม่สามารถเปลี่ยนแปลงได้
                        เว้นแต่กรณีในระหว่างการใช้งานตามแพ็คเกจ
                        ผู้ใช้งานประสงค์ที่จะได้รับสิทธิประโยชน์ของแพ็คเกจเพิ่มเติม
                        ผู้ใช้งานสามารถซื้อแพ็คเกจในระดับที่สูงกว่าได้ โดยผู้ใช้งานตกลงว่า
                        การเปลี่ยนแปลงแพ็คเกจนี้
                        เมื่อผู้ใช้งานแจ้งชำระค่าบริการแพ็คเกจในระดับที่สูงกว่ามายังพันธวณิช
                        ผู้ใช้งานจะได้รับสิทธิประโยชน์ตามแพ็คเกจใหม่และถือเป็นการเริ่มต้นใช้งานแพ็คเกจใหม่ทันที
                        โดยระยะเวลาที่ผู้ใช้งานสามารถใช้บริการระบบ PI ได้
                        จะรวมระยะเวลาที่เหลือจากแพ็คเกจเก่าเข้ากับแพ็คเกจใหม่
                      </li>
                      <br />
                      <li>
                        2.3 ผู้ใช้งานตกลงและเข้าใจว่า สิทธิในการเสนอจำนวนงานในบอร์ดประกาศจัดซื้อ
                        (Procurement Board) ที่ผู้ใช้งานมีสิทธิตามแพ็คเกจที่ใช้งาน
                        จะเริ่มต้นนับใหม่ในทุก ๆ วันแรกหลังจากครบเดือนการใช้งาน
                        โดยจะไม่มีการยกยอดสิทธิการใช้งานมาจากเดือนการใช้งานก่อนหน้า ทั้งนี้
                        หากในระหว่างการเสนอราคาผ่านบอร์ดประกาศจัดซื้อ (Procurement Board)
                        ของผู้ใช้งาน ที่ทางผู้ซื้อในระบบ PI ยังไม่ประกาศผลของการคัดเลือก
                        หากระยะเวลาแพ็คเกจของผู้ใช้งานสิ้นสุดระยะเวลาแล้ว
                        และผู้ใช้งานมิได้ซื้อหรือต่ออายุแพ็คเกจ
                        ในกรณีที่ผู้ใช้งานได้รับคัดเลือกจากผู้ซื้อในระบบ PI
                        พันธวณิชตกลงยินยอมให้ผู้ใช้งานยังคงมีสิทธิในการรับใบสั่งซื้อ (Purchase
                        Order/PO) ผ่านระบบ และทำธุรกรรมตามขั้นตอนต่าง ๆ จนเสร็จสิ้นธุรกรรมดังกล่าว
                      </li>
                      <br />
                      <li>
                        2.4 สิทธิการใช้งานระบบ PI ของผู้ใช้งานเป็นสิทธิแบบไม่ผูกขาด(Non-Exclusive)
                        และไม่สามารถโอนได้(Non-Transferable)
                        เว้นแต่จะได้รับความยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจากพันธวณิชเท่านั้น
                      </li>
                      <br />
                      <li>
                        2.5 ผู้ใช้งานรับทราบว่า พันธวณิชมีสิทธิเพิ่มเติม หรือแก้ไขเปลี่ยนแปลง
                        หรือระงับการให้บริการได้ ไม่ว่าในเวลาใดตามที่พันธวณิชเห็นสมควร
                        โดยอาจแจ้งให้ผู้ใช้งานทราบล่วงหน้า
                      </li>
                      <br />
                      <li>
                        2.6 ผู้ใช้งานรับทราบและตกลงว่า พันธวณิชจะจัดเก็บข้อมูลของผู้ใช้งาน
                        ซึ่งรวมถึงข้อมูลส่วนบุคคล โดยจะแสดงไว้ในฟังก์ชั่นข้อมูลผู้ขาย (Supplier
                        Profile) และฟังก์ชั่นบอร์ดประกาศจัดซื้อ (Procurement Board)
                        บนโปรแกรมคอมพิวเตอร์เพื่อเพิ่มช่องทางให้สมาชิกผู้ซื้อสามารถเข้าถึงสมาชิกผู้ขายได้สะดวกยิ่งขึ้น
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <br />
                    <b>3. หน้าที่ ข้อรับรองและข้อยืนยันของผู้ใช้งาน</b>
                    <br />
                    <br />
                    <ol>
                      <br />
                      ผู้ใช้งานตกลงที่จะผูกพันตามหน้าที่ ข้อรับรอง และข้อยืนยัน
                      ตามรายละเอียดต่อไปนี้ นับตั้งแต่เวลาที่กดยอมรับข้อกำหนดและเงื่อนไขนี้เป็นต้นไป
                      <br />
                      <br />
                      <li>
                        3.1 ผู้ใช้งานซึ่งเป็นผู้ขายตกลงว่าสิทธิใช้บริการระบบ PI จะเป็นไปตามระยะเวลา
                        และเงื่อนไขของแต่ละแพ็คเกจที่ผู้ใช้งานเลือกเท่านั้น
                      </li>
                      <br />
                      <li>
                        3.2 ผู้ใช้งานจะนำข้อมูลเข้าสู่ระบบ PI เฉพาะข้อมูลที่ไม่ขัดหรือแย้งต่อกฎหมาย
                        และศีลธรรมอันดีของประชาชน มีความถูกต้อง เป็นความจริง
                        รวมถึงเป็นข้อมูลที่ผู้ใช้งานสามารถดำเนินการได้จริงเท่านั้น
                        และในการสื่อสารต้องใช้ข้อความที่สุภาพ และไม่ก่อให้เกิดให้เกิดความขัดแย้ง
                        เพื่อประโยชน์ในการดำเนินธุรกิจร่วมกัน ผู้ใช้งานรับรองว่า
                        ผู้ใช้งานเป็นเจ้าของหรือเป็นผู้มีสิทธิในข้อมูลที่ตนเองให้ไว้
                        และข้อมูลเหล่านั้นถูกต้อง เหมาะสม ชอบด้วยกฎหมาย
                        และไม่เป็นการละเมิดข้อกำหนดและเงื่อนไขนี้
                        และจะไม่ก่อให้เกิดความเสียหายต่อบุคคลใด ๆ และผู้ใช้งานจะเยียวยาความเสียหายใด
                        ๆ ที่พันธวณิชได้รับอันเนื่องจากการใช้ข้อมูลที่ผู้ใช้งานให้ไว้ทั้งสิ้น
                        การใช้งานระบบ PI ของผู้ใช้งาน
                        ถือว่าผู้ใช้งานยินยอมให้พันธวณิชมีสิทธิในการเก็บ ใช้ ทำซ้ำ แก้ไข ดัดแปลง
                        เผยแพร่ แปล ประมวลผล ต่อยอดผลงาน
                        หรือจำหน่ายจ่ายแจกข้อมูลที่ท่านให้ไว้ในเว็บไซต์นี้ไปได้ทั่วโลก
                      </li>
                      <br />
                      <li>
                        3.3 ผู้ใช้งานตกลงและยินยอมให้พันธวณิชใช้ดุลพินิจในการจำกัดการใช้งานชั่วคราว
                        หรือระงับการใช้งานของบัญชีผู้ใช้งานบัญชีใดบัญชีหนึ่งหรือทั้งหมดของผู้ใช้งานได้
                        ในกรณีที่พันธวณิชพบว่าข้อมูลที่ผู้ใช้งานนำเข้าสู่ระบบ PI นั้น
                        อาจขัดกับข้อความที่ระบุในข้อ 3.2 ข้างต้น
                        หรือพันธวณิชได้รับข้อร้องเรียนจากผู้ซื้อในระบบ PI
                        ให้ตรวจสอบความถูกต้องของข้อมูลนั้น
                        หรือพันธวณิชพิจารณาแล้วเห็นว่าการนำเข้าข้อมูลนั้นอาจนำไปสู่ความเสียหายใด ๆ
                        ในภายหลัง
                      </li>
                      <br />
                      <li>
                        3.4 ผู้ใช้งานตกลงว่า ในกรณีที่ผู้ใช้งานกดตอบรับงานในบอร์ดประกาศจัดซื้อ
                        (Procurement Board)
                        ให้ถือว่าเป็นการยืนยันราคาและตกลงที่จะสละสิทธิในการเปลี่ยนแปลงราคานั้น
                      </li>
                      <br />
                      <li>
                        3.5 ผู้ใช้งานตกลงว่าจะไม่ประกาศความต้องการสรรหาสินค้า และ/หรือบริการ
                        รวมถึงเสนอขายสินค้าและ/หรือบริการ ที่ต้องห้ามตามกฎหมาย หรือตามรายการ
                        หรือประเภทที่พันธวณิชกำหนด หรืออาจกำหนดขึ้นในอนาคต
                      </li>
                      <br />
                      <li>
                        3.6
                        ผู้ใช้งานรับรองและยืนยันว่าจะเก็บรักษาข้อมูลแสดงตัวผู้ใช้งานของบัญชีผู้ใช้งานทั้งหมดให้เป็นความลับ
                        และจะยินยอมให้บุคคลที่มีอำนาจกระทำการแทนผู้ใช้งานเท่านั้นที่จะสามารถเข้าถึงข้อมูลแสดงตัวผู้ใช้งานได้
                      </li>
                      <br />
                      <li>
                        3.7 ผู้ใช้งานตกลงว่า การกระทำใด ๆ
                        ที่เกิดขึ้นจากบัญชีผู้ใช้งานบัญชีหนึ่งบัญชีใด หรือทั้งหมดของผู้ใช้งาน
                        เป็นการใช้งานในนามของผู้ใช้งาน
                        โดยผู้ใช้งานเองหรือโดยผู้มีอำนาจกระทำการแทนผู้ใช้งาน
                        ไม่ว่าผู้ใช้งานจะเป็นบุคคลธรรมดา หรือนิติบุคคล
                      </li>
                      <br />
                      <li>
                        3.8 ผู้ใช้งานมีสิทธิในการยุติการใช้บริการ
                        หรือยกเลิกบัญชีผู้ใช้งานก่อนสิ้นสุดระยะเวลาของแพ็คเกจ ทั้งนี้
                        ผู้ใช้งานตกลงสละสิทธิในการเรียกร้องขอคืนเงินค่าบริการ ค่าชดเชย ค่าเสียหาย
                        หรือค่าใช้จ่ายใด ๆ จากพันธวณิช
                      </li>
                      <br />
                      <li>
                        3.9 ผู้ใช้งานตกลงและยอมรับว่า
                        พันธวณิชมีสิทธิใช้ดุลพินิจในการระงับการใช้งานของบัญชีผู้ใช้งานบัญชีใดบัญชีหนึ่งหรือทั้งหมดของผู้ใช้งาน
                        อันเนื่องจากการไม่ปฏิบัติตามข้อกำหนดและเงื่อนไขนี้ของผู้ใช้งาน
                        และให้ถือเป็นการสิ้นสุดการใช้งานระบบ PI ไปโดยปริยาย
                        โดยผู้ใช้งานตกลงจะไม่เรียกร้องขอคืนเงินค่าบริการ ค่าชดเชย ค่าเสียหาย
                        หรือค่าใช้จ่ายอื่นใดจากพันธวณิช
                      </li>
                      <br />
                      <li>
                        3.10 หากการใช้งานระบบ PI ผ่านบัญชีผู้ใช้งานบัญชีใดบัญชีหนึ่งของผู้ใช้งาน
                        ก่อให้เกิดความเสียหาย หรือเกิดข้อพิพาทใด ๆ
                        รวมถึงแต่ไม่จำกัดเพียงความเสียหายต่อชื่อเสียง ทรัพย์สิน แก่ระบบ PI
                        หรือพันธวณิชไม่ว่าด้วยวิธีใด ๆ ทั้งทางตรงและทางอ้อม
                        ผู้ใช้งานตกลงรับผิดชอบในการแก้ไขปัญหา และระงับข้อพิพาทด้วยตนเอง
                        รวมถึงชดใช้ค่าเสียหาย และค่าใช้จ่ายใด ๆ
                        ทั้งหมดที่เกิดขึ้นให้แก่พันธวณิชทั้งสิ้น
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <br />
                    <b>4. บัญชีผู้ใช้งานและการรักษาความปลอดภัย</b>
                    <br />
                    <ol>
                      <br />
                      <li>
                        4.1 เพื่อเป็นการรักษาความปลอดภัยในการทำธุรกรรมของผู้ใช้งาน
                        ผู้ใช้งานต้องระบุข้อมูลแสดงตัวผู้ใช้งานทุกครั้งเพื่อที่จะเข้าสู่และใช้งานระบบ
                        PI
                      </li>
                      <br />
                      <li>
                        4.2
                        ผู้ใช้งานตกลงว่าบัญชีผู้ใช้งานที่ทำการกดตกลงตามข้อกำหนดและเงื่อนไขนี้จะเป็นบัญชีผู้ใช้งานเดียวที่จะมีสิทธิในการกำหนดมอบสิทธิการใช้งานระบบ
                        PI ตามสิทธิที่ได้รับให้แก่บัญชีผู้ใช้งานของผู้ใช้งาน
                      </li>
                      <br />
                      <li>
                        4.3 ผู้ใช้งานตกลงเก็บรักษาข้อมูลแสดงตัวผู้ใช้งานไว้เป็นความลับ ทั้งนี้
                        ผู้ใช้งานตกลงที่จะแจ้งให้พันธวณิช
                        ทราบโดยทันทีหากปรากฏว่ามีผู้ใช้โปรแกรมคอมพิวเตอร์
                        หรือข้อมูลแสดงตัวผู้ใช้งานโดยไม่ได้รับอนุญาต
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <br />
                    <b>5. หน้าที่ของพันธวณิช</b>
                    <br />
                    <br />
                    <ol>
                      <br />
                      ผู้ใช้งานตกลง และเข้าใจอย่างชัดเจนถึงหน้าที่และข้อรับรองของพันธวณิช
                      ดังต่อไปนี้
                      <br />
                      <br />
                      <li>
                        5.1 พันธวณิชเป็นเพียงผู้ให้บริการระบบ PI และบริการอื่นที่เกี่ยวข้อง
                        เพื่อการวิเคราะห์ข้อมูลเกี่ยวกับธุรกรรมการสั่งซื้อสินค้าระหว่างผู้ซื้อและผู้ใช้งาน
                        ทั้งนี้ พันธวณิช มิได้เป็นตัวแทนหรือนายหน้าให้กับบุคคลใดบุคคลหนึ่ง
                        และไม่มีส่วนเกี่ยวข้องในนิติกรรมสัญญาระหว่างผู้ซื้อและผู้ขาย การนำเสนอ
                        การตอบรับราคาหรือธุรกรรมใด ๆ
                        ที่เกิดขึ้นหรืออันเป็นผลสืบเนื่องมาจากการใช้งานระบบ PI โดยระบบ PI
                        จะแสดงเฉพาะข้อมูลที่ได้รับมาจากผู้ใช้งานเพื่อทำให้ผู้ใช้งานสามารถทำธุรกรรมให้เกิดขึ้นเป็นผลสำเร็จตามที่ผู้ใช้งานประสงค์ที่จะทำธุรกรรมเท่านั้น
                      </li>
                      <br />
                      <li>
                        5.2 เนื่องจากพันธวณิช
                        ไม่ได้มีส่วนเกี่ยวข้องกับความตกลงระหว่างผู้ซื้อและผู้ใช้งาน ผู้ใช้งานตกลงว่า
                        พันธวณิชไม่มีหน้าที่ต้องรับผิดใด ๆ ตามข้อเรียกร้อง ความต้องการ ในความเสียหาย
                        หรือการสูญหายใด ๆ ที่อาจเกิดขึ้นหรือเป็นผลสืบเนื่องหรือในทางใด ๆ
                        อันเกิดจากการใช้บริการระบบ PI ของผู้ใช้งาน รวมทั้งข้อพิพาทและขัดแย้งใด ๆ
                        ที่เกิดขึ้นระหว่างผู้ซื้อหรือผู้ใช้งานอื่นใดที่ใช้บริการระบบ PI นอกจากนี้
                        พันธวณิช ไม่ต้องรับผิดชอบสำหรับการผิดสัญญาใด ๆ
                        ระหว่างผู้ใช้งานกับผู้ซื้ออันเกี่ยวกับข้อตกลงในธุรกรรมใด ๆ
                        หรือกิจกรรมที่เกี่ยวข้องกับธุรกรรมนั้น ๆ ไม่ว่าจะเกิดขึ้นภายในระบบ PI
                        หรือไม่ก็ตาม
                      </li>
                      <br />
                      <li>
                        5.3 พันธวณิช ไม่ต้องรับผิดชอบสำหรับการเรียกเก็บหรือการนำส่งภาษีใดๆ
                        ยกเว้นแต่จากรายได้ของพันธวณิชเอง
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <br />
                    <b>6. ค่าบริการการใช้งานระบบ PI</b>
                    <br />
                    <br />
                    <ol>
                      ผู้ใช้งานตกลงและยินยอมตามรายละเอียดค่าใช้บริการ ดังต่อไปนี้
                      <br />
                      <br />
                      <li>
                        6.1 ผู้ใช้งานตกลงชำระค่าบริการตามแพ็คเกจที่เลือกเต็มจำนวนล่วงหน้า
                        โดยผู้ใช้งานจะมีสิทธิใช้งานนับตั้งแต่วันที่ผู้ใช้งานแจ้งรายละเอียดการชำระค่าบริการแก่พันธวณิชผ่านระบบ
                        PI
                      </li>
                      <br />
                      <li>
                        6.2 ในกรณีที่ผู้ใช้งานแจ้งรายละเอียดการชำระค่าบริการผ่านระบบ PI แล้ว
                        แต่พันธวณิชตรวจสอบแล้วไม่พบรายการชำระค่าบริการดังกล่าว
                        พันธวณิชขอสงวนสิทธิ์ในการระงับการให้บริการระบบจนกว่าจะตรวจพบรายการชำระดังกล่าว
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <br />
                    <b>7. ช่องทางติดต่อ</b>
                    <br />
                    <ol>
                      <br />
                      หากผู้ใช้งานประสบปัญหาการใช้งานสามารถติดต่อได้ที่ช่องทางต่อไปนี้
                      <br />
                      <br />
                      บริษัท พันธวณิช จำกัด <br />
                      1168/94 อาคารลุมพินีทาวเวอร์ ชั้นที่ 31 ถนนพระราม 4 แขวงทุ่งมหาเมฆ เขตสาทร
                      กรุงเทพมหานคร 10120
                      <br />
                      โทรศัพท์: 0-2034-4488, โทรสาร: 0-2679-7474, อีเมล: customercare@pantavanij.com
                    </ol>
                  </li>
                  <br />
                  <li>
                    <br />
                    <b>8. ทรัพย์สินทางปัญญา</b>
                    <br />
                    <br />
                    <ol>
                      ผู้ใช้งานรับทราบว่า พันธวณิชเป็นเจ้าของระบบ PI
                      และเป็นผู้ทรงสิทธิในทรัพย์สินทางปัญญาของระบบ PI แต่เพียงผู้เดียว
                      โดยพันธวณิชมีสิทธิแต่เพียงผู้เดียวในการปรับปรุง หรือแก้ไขเพิ่มเติมระบบ PI ได้
                      ไม่ว่าในเวลาใด
                    </ol>
                  </li>
                  <br />
                  <li>
                    <br />
                    <b>9. การรับประกันและข้อจำกัด</b>
                    <br />
                    <ol>
                      <br />
                      <li>
                        9.1 พันธวณิชรับรองว่าระบบ PI จะทำงานได้ตามสภาพและข้อกำหนดคุณลักษณะ
                        (Specifications) ซึ่งผู้ใช้งานได้ทราบและยอมรับแล้ว
                      </li>
                      <br />
                      <li>
                        9.2 พันธวณิชไม่รับประกันเกี่ยวกับ มูลค่าการขาย รายได้ กำไรผลประโยชน์
                        หรือความเสียหายอื่น ๆ
                        ที่ผู้ใช้งานอาจได้รับในระหว่างใช้งานโปรแกรมคอมพิวเตอร์และ ตลอดจนบุคคลใด ๆ
                        ภายใต้การควบคุมดูแลของผู้ใช้งาน
                      </li>
                      <br />
                      <li>
                        9.3 พันธวณิชไม่รับประกันว่า การปฏิบัติงานของระบบ PI
                        ตลอดจนเอกสารประกอบการใช้งานจะไม่ถูกรบกวน หรือเกิดความผิดพลาด
                        หากเกิดเหตุการณ์ดังกล่าว พันธวณิชจะดำเนินการแก้ไขปัญหาตามขั้นตอน
                        และวิธีปฏิบัติของพันธวณิชทันทีที่ได้รับแจ้งปัญหาจากผู้ใช้งาน
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <br />
                    <b>10. การรักษาข้อมูลความลับ</b>
                    <br />
                    <ol>
                      <br />
                      <li>
                        10.1 พันธวณิชและผู้ใช้งานจะไม่เปิดเผยข้อมูลที่เป็นความลับ หรือข้อมูลใด ๆ
                        ที่ได้รับจากฝ่ายที่เปิดเผยข้อมูลให้แก่บุคคลใด ๆ ตลอดระยะเวลาการใช้งานระบบ PI
                        ของผู้ใช้งาน โดยไม่ได้รับความยินยอมจากฝ่ายที่เปิดเผยข้อมูล ภายใต้เงื่อนไขว่า
                        แต่ละฝ่ายอาจเปิดเผยข้อมูลที่เป็นความลับของคู่สัญญาอีกฝ่ายหนึ่ง: (1)
                        ให้แก่ลูกจ้าง ที่ปรึกษา กรรมการ ตัวแทนหรือผู้รับจ้างใด ๆ
                        เพื่อวัตถุประสงค์ในการบริหารงานภายในของตน หรือเพื่อประโยชน์ในการดำเนินการใด
                        ๆ ภายใต้ข้อกำหนดและเงื่อนไขนี้ หรือ (2) ให้แก่นิติบุคคลที่มีอำนาจควบคุม,
                        นิติบุคคลที่อยู่ภายใต้การควบคุม และบริษัทในเครือ
                        เพื่อวัตถุประสงค์ด้านการตลาด เช่น นำเสนอสิทธิประโยชน์ และ/หรือผลิตภัณฑ์ใดๆ
                        หรือบริการ ตลอดจนการทำสถิติ, วิเคราะห์, ศึกษาวิจัย, ประเมินผลข้อมูล
                        หรือเพื่อจัดการความต้องการทางธุรกิจของคู่สัญญาแต่ละฝ่าย, คู่ค้า
                        หรือบริษัทในเครือเท่านั้น ทั้งนี้
                        คู่สัญญาฝ่ายที่ได้รับข้อมูลต้องควบคุมดูแลให้ผู้ที่ได้รับข้อมูลดังกล่าวไม่เปิดเผยข้อมูลให้บุคคลอื่น
                        ๆ
                      </li>
                      <br />
                      <li>
                        10.2 เงื่อนไขการรักษาความลับในข้อ 10.1 จะไม่ใช้บังคับกับข้อมูลที่เป็นความลับ
                        หรือข้อมูลใด ๆ ในกรณีดังต่อไปนี้
                        <ol>
                          <li>
                            (1) กรณีที่ต้องเปิดเผยข้อมูลที่เป็นความลับตามกฎหมาย
                            หรือตามคำสั่งโดยชอบด้วยกฎหมายของเจ้าพนักงานผู้มีอำนาจ
                            ฝ่ายที่เปิดเผยข้อมูลนั้นต้องแจ้งการเปิดเผยข้อมูลที่เป็นความลับให้ฝ่ายเจ้าของข้อมูลทราบก่อนเปิดเผยด้วย
                          </li>
                          <li>(2) กรณีที่ข้อมูลที่เป็นความลับได้กลายเป็นข้อมูลสาธารณะหรือ</li>
                          <li>
                            (3) กรณีที่เป็นข้อมูลที่ฝ่ายที่ได้รับข้อมูลได้พัฒนาหรือปรับปรุงขึ้นเอง
                            โดยไม่มีส่วนหนึ่งส่วนใดที่แสดงให้เห็น หรือทราบได้ถึงข้อมูลที่เป็นความลับ
                            ไม่ว่าโดยชัดแจ้งหรือโดยปริยาย
                          </li>
                        </ol>
                      </li>
                      <br />
                      <li>
                        10.3 กรณีข้อมูลของผู้ใช้งานเป็นข้อมูลส่วนบุคคล
                        เพื่อให้ผู้ใช้งานมั่นใจว่าข้อมูลส่วนบุคคลของผู้ใช้งานที่เปิดเผยให้แก่พันธวณิชจะได้รับความปลอดภัย
                        พันธวณิชตกลงปฏิบัติตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
                        รวมถึงกฎ และระเบียบใดๆ ที่เกี่ยวข้องอย่างเคร่งครัด
                        ซึ่งผู้ใช้งานสามารถตรวจสอบได้จาก นโยบายการคุ้มครองข้อมูลส่วนบุคคลของพันธวณิช
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <br />
                    <b>11. การชดใช้ค่าเสียหายและการจำกัดความรับผิด</b>
                    <br />
                    <br />
                    <ol>
                      นอกจากที่กำหนดไว้ในข้อกำหนดและเงื่อนไขนี้แล้ว พันธวณิชและผู้ใช้งานตกลงว่า
                      การชดใช้ค่าเสียหายระหว่างกันตามข้อกำหนดและเงื่อนไขนี้ไม่ว่าจะเกิดจากกรณีใด ๆ
                      ก็ตามจะต้องเป็นค่าเสียหายที่เกิดขึ้นตามจริงและพิสูจน์ได้ด้วยเอกสารหลักฐานที่เชื่อถือได้
                      และไม่รวมถึงค่าเสียหายโดยอ้อมที่เกิดจากการสูญเสียรายได้และ/หรือกำไร
                      การชะงักงันทางธุรกิจ การสูญเสียข้อมูลทางธุรกิจและ/หรือข้อมูลทั่วไป
                      และ/หรือค่าเสียหายที่ไม่สามารถคาดการณ์ได้ นอกจากนั้น
                      ค่าเสียหายรวมแล้วทั้งหมดจะต้องไม่เกินค่าบริการแพคเกจที่ผู้ใช้งานเลือกใช้ในช่วงที่เกิดความเสียหายดังกล่าว
                      และได้ชำระให้แก่พันธวณิชเรียบร้อยแล้ว (หากมี)
                      ในกรณีที่ไม่มีการชำระค่าบริการดังกล่าว
                      ผู้ใช้บริการยินยอมสละซึ่งสิทธิในการเรียกร้องค่าเสียหายใด ๆ
                      อันเกิดจากการใช้บริการของพันธวณิชไม่ว่าโดยทางตรงหรือทางอ้อม
                    </ol>
                  </li>
                  <br />
                  <li>
                    <br />
                    <b>12. ระยะเวลาของการใช้งานและการต่ออายุการใช้งานระบบ PI</b>
                    <br />
                    <ol>
                      <br />
                      <li>
                        12.1 พันธวณิชตกลงให้ผู้ใช้งานมีสิทธิในการใช้งานระบบ PI
                        ภายใต้ข้อกำหนดและเงื่อนไขนี้
                        นับตั้งแต่วันที่ผู้ใช้งานแจ้งรายละเอียดการชำระค่าบริการแก่พันธวณิชผ่านระบบ
                        PI มีผลใช้บังคับ และจะมีผลใช้บังคับต่อไปจนครบกำหนดเวลาของแพ็คเกจ
                      </li>
                      <br />
                      <li>
                        12.2 การนับระยะเวลาการใช้งานแพ็คเกจตามข้อตกลงและเงื่อนไขนี้
                        ให้เป็นไปตามกำหนดวัน เดือน ปี ตามปฏิทิน
                        กรณีวันที่เริ่มใช้งานแพ็คเกจเป็นวันสุดท้ายของเดือน
                        วันที่ครบกำหนดเดือนคือวันสุดท้ายของแต่ละเดือนตามปฏิทิน
                      </li>
                      <br />
                      <li>
                        12.3 ผู้ใช้งานตกลงและยอมรับว่า ในระหว่างที่บัญชีผู้ใช้งานถูกระงับโดยพันธวณิช
                        การนับระยะเวลาของแพ็คเกจจะหยุดลงในขณะนั้นด้วย
                        หากในภายหลังพันธวณิชพิจารณาสิ้นสุดการระงับบัญชีดังกล่าวแล้ว
                        ให้นำจำนวนวันที่ถูกระงับการใช้งานนับเพิ่มต่อจากระยะเวลาของแพ็คเกจเดิม
                        โดยถือเป็นการแทนที่กำหนดระยะเวลาการใช้งานของแพ็คเกจ
                      </li>
                      <br />
                      <li>
                        12.4 หากผู้ใช้งานต่ออายุแพ็คเกจเพิ่มเติม
                        ระยะเวลาและเงื่อนไขการใช้งานของแพ็คเกจที่เพิ่มเติมดังกล่าวจะเริ่มมีผลในวันถัดจากวันสุดท้ายของแพ็คเกจเดิม
                      </li>
                      <br />
                      <li>
                        12.5 เว้นแต่จะกำหนดไว้ในข้อกำหนดและเงื่อนไขนี้
                        เมื่อสิ้นสุดระยะเวลาของแพ็คเกจ
                        บัญชีผู้ใช้งานของผู้ใช้งานจะถูกระงับและถือว่าเป็นการสิ้นสุดการใช้งานทันที
                        อย่างโต้แย้งมิได้
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <br />
                    <b>13. การบอกเลิกการใช้งาน และผลของการสิ้นสุดการใช้งาน</b>
                    <br />
                    <ol>
                      <br />
                      ผู้ใช้งานทราบและตกลงว่า
                      <br />
                      <br />
                      <li>
                        13.1
                        พันธวณิชสงวนสิทธิ์ในการระงับการใช้งานบัญชีขอผู้ใช้งานและให้ถือว่าสิ้นสุดการใช้งานในกรณีใดกรณีหนึ่งดังต่อไปนี้
                        <br />
                        <ol>
                          <li>
                            (1)
                            ในกรณีที่ผู้ใช้งานไม่ปฏิบัติข้อกำหนดและเงื่อนไขนี้ไม่ว่าข้อหนึ่งข้อใดหรือทั้งหมด
                            โดยให้มีผลสิ้นสุดลงภายใน 30 (สามสิบ)
                            วันนับจากวันที่พันธวณิชได้แจ้งการยกเลิกสิทธิในการใช้งานให้ผู้ใช้งานทราบผ่านทางโปรแกรมคอมพิวเตอร์
                            หรือวิธีการอื่นใดที่พันธวณิชเห็นสมควร
                            เว้นแต่พันธวณิชพิจารณาให้ผู้ใช้งานชี้แจงเหตุผลและดำเนินการแก้ไขข้อผิดพลาดให้แล้วเสร็จภายในระยะเวลาที่พันธวณิชกำหนด
                            แต่ทั้งนี้ หากเป็นการละเมิดสิทธิหรือทรัพย์สินทางปัญญาที่กำหนดไว้ในข้อ 8
                            ให้ถือว่าการยกเลิกการใช้งานมีผลใช้บังคับในทันทีที่พันธวณิชได้แจ้งให้ผู้ใช้งานทราบ;
                            หรือ
                          </li>
                          <br />
                          <li>
                            (2) ในกรณีที่ผู้ใช้งาน (i) เป็นบุคคลมีหนี้สินล้นพ้นตัว (ii)
                            ทำการโอนทรัพย์สินเพื่อประโยชน์แก่เจ้าหนี้อื่น ๆ (iii)
                            ถูกตัดสินให้ตกเป็นบุคคลล้มละลาย หรือ (iv) หยุดดำเนินกิจการ
                            โดยให้มีผลสิ้นสุดภายใน 30 (สามสิบ)
                            วันนับจากวันที่พันธวณิชได้แจ้งการยกเลิกสิทธิในการใช้งานให้ผู้ใช้งานทราบผ่านทางโปรแกรมคอมพิวเตอร์หรือวิธีการอื่นใดที่พันธวณิชเห็นสมควร;
                          </li>
                          <br />
                          <li>
                            (3)
                            ในกรณีที่พันธวณิชได้แจ้งการยกเลิกสิทธิในการใช้งานให้ผู้ใช้งานทราบผ่านทางระบบ
                            PI หรือวิธีการอื่นใดที่พันธวณิชเห็นสมควร โดยให้มีผลสิ้นสุดภายใน 30
                            (สามสิบ) วันนับจากวันที่ได้แจ้งนั้น; หรือ
                          </li>
                          <br />
                          <li>
                            (4) ในกรณีที่เกิดเหตุสุดวิสัยตามที่กำหนดไว้ในข้อ 15
                            และยังคงมีอยู่เกินกว่า 15 (สิบห้า) วัน ติดต่อกัน
                          </li>
                        </ol>
                      </li>
                      <br />
                      <li>
                        13.2 ผู้ใช้งานตกลงว่า
                        การบอกเลิกการใช้งานไม่ว่าจากฝ่ายใดจะไม่เป็นการก่อสิทธิในการขอคืนเงินค่าบริการ
                        ค่าชดเชย ค่าเสียหาย หรือค่าใช้จ่ายใด ๆ ต่อพันธวณิช
                      </li>
                    </ol>
                  </li>
                  <br />
                  <li>
                    <br />

                    <b>14. ผลของการสิ้นสุดการใช้งาน</b>
                    <br />

                    <ol>
                      <br />
                      <li>
                        14.1 หลังจากการใช้งานตามข้อกำหนดและเงื่อนไขนี้มีผลเป็นอันสิ้นสุดลง
                        ผู้ใช้งานจะถูกจำกัดการใช้งานระบบ PI
                        รวมถึงไม่สามารถเข้าถึงข้อมูลรายการสินค้าที่มีการประกาศในบอร์ดประกาศจัดซื้อ
                        (Procurement Board)
                      </li>
                      <br />

                      <li>
                        14.2 พันธวณิชอาจยกเลิกข้อมูลแสดงตัวผู้ใช้งาน ลบไฟล์ข้อมูลในบัญชีของผู้ใช้งาน
                        รวมถึงขัดขวางเพื่อป้องกันการเข้าสู่ไฟล์ข้อมูลทันทีที่การใช้งานมีผลเป็นอันสิ้นสุดลง
                      </li>
                      <br />
                    </ol>
                  </li>
                  <br />
                  <li>
                    <br />

                    <b>15. เหตุสุดวิสัย</b>
                    <br />
                    <br />
                    <ol>
                      หากพันธวณิชไม่สามารถปฏิบัติหน้าที่ตามข้อกำหนดและเงื่อนไขนี้ไม่ว่าทั้งหมดหรือแต่บางส่วนเนื่องจากมีเหตุสุดวิสัย
                      พันธวณิชจะแจ้งให้ผู้ใช้งานทราบผ่านทางระบบ PI
                      หรือวิธีการอื่นใดที่พันธวณิชเห็นสมควรในทันทีหลังจากที่เกิดเหตุสุดวิสัยดังกล่าว
                      และให้ถือว่าพันธวณิชหลุดพ้นจากหน้าที่ตามที่กำหนดในข้อกำหนดและเงื่อนไขนี้เท่าที่ได้รับผลกระทบจากเหตุสุดวิสัย
                      ข้อนี้ไม่ส่งผลให้ผู้ใช้งานหลุดพ้นจากหน้าที่ในการชำระเงินใด ๆ ที่เกิดขึ้น
                      (หากมี)
                    </ol>
                    <br />
                  </li>
                  <br />
                  <li>
                    <br />

                    <b>16. การบอกกล่าว</b>
                    <br />
                    <br />
                    <ol>
                      บรรดาหนังสือบอกกล่าวและหรือเอกสารใด ๆ ที่ต้องส่งให้แก่ฝ่ายใดฝ่ายหนึ่ง
                      จะต้องส่งให้ตามที่อยู่ที่ได้แจ้งให้ทราบ หรือที่ปรากฏในหนังสือรับรอง
                      หรือในเอกสารราชการใด ๆ หรือที่อยู่จดหมายอิเล็กทรอนิกส์ ในวันที่มีผลใช้บังคับ
                      โดยให้ถือว่าการส่งคำบอกกล่าวด้วยตนเอง หรือทางไปรษณีย์ลงทะเบียน หรือโทรสาร
                      หรือแบบอิเล็กทรอนิกส์ เป็นการส่งโดยชอบแล้วนับแต่เวลาที่ได้ส่งโดยวิธีการนั้น ๆ
                      แล้วในกรณีที่ฝ่ายใดฝ่ายหนึ่งเปลี่ยนแปลงที่อยู่หรือข้อมูลสถานะบุคคลในเวลาใด ๆ
                      ให้ฝ่ายนั้นดำเนินการปรับปรุงข้อมูลที่ปรากฏในระบบ PI ภายใน 7 (เจ็ด)
                      วันนับจากวันที่มีการเปลี่ยนแปลงนั้น
                      และให้ถือว่าอีกฝ่ายหนึ่งได้รับทราบการแจ้งเปลี่ยนแปลงดังกล่าวแล้ว ณ
                      วันที่ได้แจ้งนั้น
                    </ol>
                  </li>
                  <br />
                  <li>
                    <br />

                    <b>17. ข้อตกลงอื่น</b>

                    <ol>
                      <br />
                      <li>
                        17.1 ตลอดระยะเวลาของการใช้งานระบบ PI ผู้ใช้งานรับรองต่อพันธวณิชว่า
                        การตกลงตามข้อกำหนดและเงื่อนไขนี้เป็นเรื่องที่อยู่ภายในขอบเขตวัตถุที่ประสงค์ทางธุรกิจของผู้ใช้งาน
                        (ไม่ว่าในทางตรงหรือทางอ้อม)
                        ที่จดทะเบียนไว้แล้วกับหน่วยงานราชการที่เกี่ยวข้อง
                        และผู้ใช้งานมีสิทธิและหน้าที่โดยชอบด้วยกฎหมายทุกประการที่จะปฏิบัติตามข้อกำหนดและเงื่อนไขนี้อย่างเคร่งครัด
                        โดยไม่ถือว่าเป็นการปฏิบัตินอกเหนือวัตถุที่ประสงค์ทางธุรกิจของผู้ใช้งาน
                        หรือเป็นการละเมิดหรือฝ่าฝืนกฎหมายใด ๆ ที่ใช้บังคับกับข้อกำหนดและเงื่อนไขนี้
                        หรือใช้บังคับกับผู้ใช้งาน และไม่ถือว่ากรณีดังกล่าวมีผลกระทบต่อความสมบูรณ์
                        หรือการใช้บังคับของข้อกำหนดและเงื่อนไขนี้
                        หรือเป็นการปลดเปลื้องหรือลบล้างข้อผูกพันของผู้ใช้งานภายใต้ข้อกำหนดและเงื่อนไขนี้ด้วยประการใด
                        ๆ ทั้งสิ้น โดยให้ถือว่าผู้ใช้งาน กรรมการ และผู้ถือหุ้นของผู้ใช้งาน (หากมี)
                        ได้ให้สัตยาบันต่อข้อผูกพันของผู้ใช้งานทุกอย่างภายใต้สัญญานี้แล้วโดยผ่านการตกลงตามข้อตกลงและเงื่อนไขนี้อีกประการหนึ่งด้วย
                      </li>
                      <br />

                      <li>
                        17.2
                        การเพิกเฉยของคู่สัญญาฝ่ายใดฝ่ายหนึ่งในการบังคับตามข้อตกลงภายใต้ข้อกำหนดและเงื่อนไขฉบับนี้ไม่ถือว่าคู่สัญญาฝ่ายนั้นสละสิทธิหรือยกเว้นข้อตกลงนั้น
                        หรือไม่ถือว่าคู่สัญญาฝ่ายนั้นสละสิทธิของตนเองในการบังคับตามข้อตกลงดังกล่าวในภายหลัง
                        ตลอดจนไม่ถือเป็นการตกลงสละสิทธิหรือยกเว้นในการผิดข้อตกลงนั้นหรือข้อตกลงอื่น
                        ต่อไปภายใต้ข้อกำหนดและเงื่อนไขฉบับนี้
                      </li>
                      <br />

                      <li>
                        17.3 หากข้อใดข้อหนึ่งเป็นโมฆะหรือไม่สมบูรณ์ไม่ว่าด้วยเหตุผลใด ๆ ก็ตาม
                        ให้แยกส่วนที่เป็นโมฆะหรือที่ไม่สมบูรณ์นั้นออกจากข้ออื่น ๆ ที่สมบูรณ์
                        และให้ข้อที่ยังสมบูรณ์อยู่มีผลผูกพันต่อไป
                      </li>
                      <br />

                      <li>
                        17.4 ข้อกำหนดและเงื่อนไขฉบับนี้ รวมถึงข้อพิพาทใด ๆ
                        ที่เกิดขึ้นเกี่ยวกับการปฏิบัติตามข้อกำหนดและเงื่อนไขนี้ให้ตีความตามกฎหมายไทย
                      </li>
                      <br />

                      <li>
                        17.5
                        ความสัมพันธ์ระหว่างผู้ใช้งานและพันธวณิชที่เกิดขึ้นภายใต้ข้อกำหนดและเงื่อนไขนี้
                        จำกัดเพียงความสัมพันธ์ของการเป็นผู้ให้บริการและผู้รับบริการเพื่อวัตถุประสงค์ในการใช้บริการระบบ
                        PI เท่านั้น
                        อีกทั้งข้อกำหนดและเงื่อนไขนี้ไม่มีข้อกำหนดใดที่จะตีความได้ว่าคู่สัญญาฝ่ายใดเป็นตัวแทนของคู่สัญญาอีกฝ่ายหนึ่งไม่ว่าเพื่อวัตถุประสงค์ใดก็ตาม
                        และไม่มีคู่สัญญาฝ่ายใดจะสามารถก่อให้เกิดหน้าที่ หรือความรับผิดใด ๆ
                        ในนามคู่สัญญาอีกฝ่ายหนึ่ง หรือผูกพันคู่สัญญาอีกฝ่ายหนึ่งได้
                      </li>
                      <br />

                      <li>
                        17.6 รายละเอียด เงื่อนไข ของการใช้งานและค่าบริการในการใช้งานระบบ PI
                        ให้ถือเป็นส่วนหนึ่งของข้อกำหนดและเงื่อนไขฉบับนี้ด้วย
                      </li>
                    </ol>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <Modal.Footer className="xs-full-button">
          <div className="text-right">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Back
            </button>
            <button type="submit" className="btn btn-primary" onClick={handleSubmit}>
              Accept and Continue
            </button>
          </div>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default TermModal;
